"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/drawer/examples/index.ts';
var DrawerExample = /** @class */ (function () {
    function DrawerExample() {
        this.closeOnEscapeKey = true;
        this.closeOnOutsideClick = true;
        this.hasBackdrop = true;
        this.inline = false;
        this.isOpen = false;
        this.position = 'right';
    }
    DrawerExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)('.cui-example-overflow-hidden', [
                (0, mithril_1.default)(_1.Drawer, {
                    closeOnEscapeKey: this.closeOnEscapeKey,
                    closeOnOutsideClick: this.closeOnOutsideClick,
                    content: [
                        (0, mithril_1.default)('h4', 'Drawer Content'),
                        (0, mithril_1.default)(_1.Button, {
                            label: 'Close Drawer',
                            onclick: function () { return _this.isOpen = false; }
                        })
                    ],
                    hasBackdrop: this.hasBackdrop,
                    position: this.position,
                    isOpen: this.isOpen,
                    inline: this.inline,
                    onClose: function () { return _this.isOpen = false; }
                })
            ]),
            (0, mithril_1.default)(_1.Button, {
                label: 'Show drawer',
                intent: 'primary',
                onclick: function () { return _this.isOpen = !_this.isOpen; }
            })
        ]);
    };
    DrawerExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Position'),
            (0, mithril_1.default)(_1.Select, {
                options: Object.keys(_1.DrawerPosition).map(function (key) { return _1.DrawerPosition[key]; }),
                onchange: function (e) { return _this.position = e.target.value; },
                size: 'xs',
                fluid: true,
                value: this.position
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnEscapeKey,
                label: 'Close on ESC key',
                onchange: function () { return _this.closeOnEscapeKey = !_this.closeOnEscapeKey; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnOutsideClick,
                label: 'Close on outer click',
                onchange: function () { return _this.closeOnOutsideClick = !_this.closeOnOutsideClick; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.inline,
                label: 'Render inline',
                onchange: function () { return _this.inline = !_this.inline; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasBackdrop,
                label: 'Has backdrop',
                onchange: function () { return _this.hasBackdrop = !_this.hasBackdrop; }
            })
        ];
    };
    return DrawerExample;
}());
exports.DrawerExample = DrawerExample;
